<template>
  <el-select
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    :clearable="clearable"
    :multiple="multiple"
    v-bind="$attrs"
    v-on="listeners"
  >
    <el-option
      v-for="item in options"
      :key="item.dictValue"
      :label="item.dictLabel"
      :value="item.dictValue"
    />
  </el-select>
</template>

<script>
/**
 * DictSelect — 字典下拉选择组件
 *
 * 支持 v-model 双向绑定，挂载时自动按 dictType 拉取字典数据。
 *
 * Props:
 *   dictType  (String, 必填) 字典类型标识，如 'tool_type'
 *   value     (String/Array) 当前选中值，配合 v-model 使用
 *   disabled  (Boolean) 是否禁用
 *   clearable (Boolean) 是否可清空，默认 true
 *   multiple  (Boolean) 是否多选
 *   placeholder (String) 占位文字
 *
 * 用法示例：
 *   <DictSelect v-model="form.toolType" dict-type="tool_type" />
 *   <DictSelect v-model="form.toolType" dict-type="tool_type" disabled />
 */
import { getDictDataByType } from './dict.api';

export default {
  name: 'DictSelect',
  inheritAttrs: false,

  props: {
    dictType: { type: String, required: true },
    value: { type: [String, Number, Array], default: '' },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    multiple: { type: Boolean, default: false },
    placeholder: { type: String, default: '请选择' }
  },

  data() {
    return {
      options: []
    };
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: (val) => this.$emit('input', val),
        change: (val) => this.$emit('change', val)
      };
    }
  },

  watch: {
    dictType: {
      immediate: true,
      handler(val) {
        if (val) this.loadOptions(val);
      }
    }
  },

  methods: {
    async loadOptions(dictType) {
      try {
        this.options = await getDictDataByType(dictType);
      } catch (e) {
        this.options = [];
        console.warn('[DictSelect] 字典数据加载失败:', dictType, e);
      }
      this.$emit('options-loaded', {
        dictType,
        options: this.options,
        isEmpty: !this.options || this.options.length === 0
      });
    }
  }
};
</script>
